/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Brevalt API
 * Customer API of Brevalt (CRA vulnerability reporting). Errors are RFC 9457 problem+json.
 * OpenAPI spec version: 0.29.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ClassifierAnswers,
  CraClassification,
  CraQuestionnaire,
  DiffVersionsParams,
  ExtraProductRequired,
  GetVersionHistoryParams,
  ListProductSummariesParams,
  ListProductsParams,
  Problem,
  Product,
  ProductCreate,
  ProductCreated,
  ProductPage,
  ProductRestore,
  ProductSummary,
  ProductUpdate,
  ProductVersion,
  Uuid,
  VersionCreate,
  VersionDiff,
  VersionHistoryEntry,
  VersionUpdate
} from '../model';

import { customerFetch } from '../../../http.ts';
import type { ErrorType } from '../../../http.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetCraQuestionnaireUrl = () => {




  return `/api/v1/cra-classifier`
}

/**
 * @summary The CRA classifier questions, options and outcomes
 */
export const getCraQuestionnaire = async ( options?: Parameters<typeof customerFetch>[1]): Promise<CraQuestionnaire> => {

  return customerFetch<CraQuestionnaire>(getGetCraQuestionnaireUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCraQuestionnaireQueryKey = () => {
    return [
    `/api/v1/cra-classifier`
    ] as const;
    }


export const getGetCraQuestionnaireQueryOptions = <TData = Awaited<ReturnType<typeof getCraQuestionnaire>>, TError = ErrorType<Problem>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCraQuestionnaire>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCraQuestionnaireQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCraQuestionnaire>>> = ({ signal }) => getCraQuestionnaire({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCraQuestionnaire>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCraQuestionnaireQueryResult = NonNullable<Awaited<ReturnType<typeof getCraQuestionnaire>>>
export type GetCraQuestionnaireQueryError = ErrorType<Problem>


export function useGetCraQuestionnaire<TData = Awaited<ReturnType<typeof getCraQuestionnaire>>, TError = ErrorType<Problem>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCraQuestionnaire>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCraQuestionnaire>>,
          TError,
          Awaited<ReturnType<typeof getCraQuestionnaire>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCraQuestionnaire<TData = Awaited<ReturnType<typeof getCraQuestionnaire>>, TError = ErrorType<Problem>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCraQuestionnaire>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCraQuestionnaire>>,
          TError,
          Awaited<ReturnType<typeof getCraQuestionnaire>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCraQuestionnaire<TData = Awaited<ReturnType<typeof getCraQuestionnaire>>, TError = ErrorType<Problem>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCraQuestionnaire>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The CRA classifier questions, options and outcomes
 */

export function useGetCraQuestionnaire<TData = Awaited<ReturnType<typeof getCraQuestionnaire>>, TError = ErrorType<Problem>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCraQuestionnaire>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCraQuestionnaireQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getEvaluateCraClassifierUrl = () => {




  return `/api/v1/cra-classifier/evaluate`
}

/**
 * 400 classifier-incomplete lists the missing questions in missing[]; classifier-invalid-answer lists the bad ones in questions[].
 * @summary Classify answers without storing them
 */
export const evaluateCraClassifier = async (classifierAnswers: ClassifierAnswers, options?: Parameters<typeof customerFetch>[1]): Promise<CraClassification> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customerFetch<CraClassification>(getEvaluateCraClassifierUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(classifierAnswers)
  }
);}





export const getEvaluateCraClassifierMutationKey = () => ['evaluateCraClassifier'] as const;

export const getEvaluateCraClassifierMutationOptions = <TError = ErrorType<void | Problem>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof evaluateCraClassifier>>, TError,EvaluateCraClassifierMutationVariables, TContext>, request?: SecondParameter<typeof customerFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof evaluateCraClassifier>>, TError,EvaluateCraClassifierMutationVariables, TContext> => {

const mutationKey = getEvaluateCraClassifierMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof evaluateCraClassifier>>, EvaluateCraClassifierMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  evaluateCraClassifier(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EvaluateCraClassifierMutationResult = NonNullable<Awaited<ReturnType<typeof evaluateCraClassifier>>>
    export type EvaluateCraClassifierMutationBody = ClassifierAnswers
    export type EvaluateCraClassifierMutationError = ErrorType<void | Problem>
    export type EvaluateCraClassifierMutationVariables = {data: ClassifierAnswers}

    /**
 * @summary Classify answers without storing them
 */
export const useEvaluateCraClassifier = <TError = ErrorType<void | Problem>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof evaluateCraClassifier>>, TError,EvaluateCraClassifierMutationVariables, TContext>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof evaluateCraClassifier>>,
        TError,
        EvaluateCraClassifierMutationVariables,
        TContext
      > => {
      return useMutation(getEvaluateCraClassifierMutationOptions(options), queryClient);
    }
    export const getListProductsUrl = (params?: ListProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/products?${stringifiedParams}` : `/api/v1/products`
}

/**
 * @summary Products in the caller's product scope, oldest first (cursor pagination)
 */
export const listProducts = async (params?: ListProductsParams, options?: Parameters<typeof customerFetch>[1]): Promise<ProductPage> => {

  return customerFetch<ProductPage>(getListProductsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProductsQueryKey = (params?: ListProductsParams,) => {
    return [
    `/api/v1/products`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProductsQueryOptions = <TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<Problem>>(params?: ListProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProductsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProducts>>> = ({ signal }) => listProducts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listProducts>>>
export type ListProductsQueryError = ErrorType<Problem>


export function useListProducts<TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<Problem>>(
 params: undefined |  ListProductsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProducts>>,
          TError,
          Awaited<ReturnType<typeof listProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProducts<TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<Problem>>(
 params?: ListProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProducts>>,
          TError,
          Awaited<ReturnType<typeof listProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProducts<TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<Problem>>(
 params?: ListProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Products in the caller's product scope, oldest first (cursor pagination)
 */

export function useListProducts<TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<Problem>>(
 params?: ListProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProductsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateProductUrl = () => {




  return `/api/v1/products`
}

/**
 * Needs access to all products. Beyond the plan's products the answer is 402 extra-product-required with the price; repeat with acceptExtraProductCharge=true to buy an extra product (03 §5.2): that needs billing.manage (403 permission-denied) and a step-up token (401 step-up-required). Trial, read-only and expired workspaces answer 403 (plan-limit-reached, workspace-read-only, trial-expired).
 * @summary Create a product (plan limits apply)
 */
export const createProduct = async (productCreate: ProductCreate, options?: Parameters<typeof customerFetch>[1]): Promise<ProductCreated> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customerFetch<ProductCreated>(getCreateProductUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(productCreate)
  }
);}





export const getCreateProductMutationKey = () => ['createProduct'] as const;

export const getCreateProductMutationOptions = <TError = ErrorType<void | Problem | ExtraProductRequired>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,CreateProductMutationVariables, TContext>, request?: SecondParameter<typeof customerFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,CreateProductMutationVariables, TContext> => {

const mutationKey = getCreateProductMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProduct>>, CreateProductMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createProduct(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProductMutationResult = NonNullable<Awaited<ReturnType<typeof createProduct>>>
    export type CreateProductMutationBody = ProductCreate
    export type CreateProductMutationError = ErrorType<void | Problem | ExtraProductRequired>
    export type CreateProductMutationVariables = {data: ProductCreate}

    /**
 * @summary Create a product (plan limits apply)
 */
export const useCreateProduct = <TError = ErrorType<void | Problem | ExtraProductRequired>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,CreateProductMutationVariables, TContext>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProduct>>,
        TError,
        CreateProductMutationVariables,
        TContext
      > => {
      return useMutation(getCreateProductMutationOptions(options), queryClient);
    }
    export const getListProductSummariesUrl = (params?: ListProductSummariesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/products/summary?${stringifiedParams}` : `/api/v1/products/summary`
}

/**
 * @summary Per product in the caller's scope: latest version, last scan, open findings by bucket and an 8-week trend (findings present at the end of each week, exploited among them)
 */
export const listProductSummaries = async (params?: ListProductSummariesParams, options?: Parameters<typeof customerFetch>[1]): Promise<ProductSummary[]> => {

  return customerFetch<ProductSummary[]>(getListProductSummariesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProductSummariesQueryKey = (params?: ListProductSummariesParams,) => {
    return [
    `/api/v1/products/summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProductSummariesQueryOptions = <TData = Awaited<ReturnType<typeof listProductSummaries>>, TError = ErrorType<Problem>>(params?: ListProductSummariesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductSummaries>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProductSummariesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProductSummaries>>> = ({ signal }) => listProductSummaries(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProductSummaries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProductSummariesQueryResult = NonNullable<Awaited<ReturnType<typeof listProductSummaries>>>
export type ListProductSummariesQueryError = ErrorType<Problem>


export function useListProductSummaries<TData = Awaited<ReturnType<typeof listProductSummaries>>, TError = ErrorType<Problem>>(
 params: undefined |  ListProductSummariesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductSummaries>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProductSummaries>>,
          TError,
          Awaited<ReturnType<typeof listProductSummaries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProductSummaries<TData = Awaited<ReturnType<typeof listProductSummaries>>, TError = ErrorType<Problem>>(
 params?: ListProductSummariesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductSummaries>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProductSummaries>>,
          TError,
          Awaited<ReturnType<typeof listProductSummaries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProductSummaries<TData = Awaited<ReturnType<typeof listProductSummaries>>, TError = ErrorType<Problem>>(
 params?: ListProductSummariesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductSummaries>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Per product in the caller's scope: latest version, last scan, open findings by bucket and an 8-week trend (findings present at the end of each week, exploited among them)
 */

export function useListProductSummaries<TData = Awaited<ReturnType<typeof listProductSummaries>>, TError = ErrorType<Problem>>(
 params?: ListProductSummariesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductSummaries>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProductSummariesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpdateProductUrl = (id: Uuid,) => {




  return `/api/v1/products/${encodeURIComponent(String(id))}`
}

/**
 * @summary Change a live product
 */
export const updateProduct = async (id: Uuid,
    productUpdate: ProductUpdate, options?: Parameters<typeof customerFetch>[1]): Promise<Product> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customerFetch<Product>(getUpdateProductUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(productUpdate)
  }
);}





export const getUpdateProductMutationKey = () => ['updateProduct'] as const;

export const getUpdateProductMutationOptions = <TError = ErrorType<Problem>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,UpdateProductMutationVariables, TContext>, request?: SecondParameter<typeof customerFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,UpdateProductMutationVariables, TContext> => {

const mutationKey = getUpdateProductMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProduct>>, UpdateProductMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateProduct(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProductMutationResult = NonNullable<Awaited<ReturnType<typeof updateProduct>>>
    export type UpdateProductMutationBody = ProductUpdate
    export type UpdateProductMutationError = ErrorType<Problem>
    export type UpdateProductMutationVariables = {id: Uuid;data: ProductUpdate}

    /**
 * @summary Change a live product
 */
export const useUpdateProduct = <TError = ErrorType<Problem>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,UpdateProductMutationVariables, TContext>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProduct>>,
        TError,
        UpdateProductMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateProductMutationOptions(options), queryClient);
    }
    export const getGetProductUrl = (id: Uuid,) => {




  return `/api/v1/products/${encodeURIComponent(String(id))}`
}

/**
 * @summary A product with its classification and warnings
 */
export const getProduct = async (id: Uuid, options?: Parameters<typeof customerFetch>[1]): Promise<Product> => {

  return customerFetch<Product>(getGetProductUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProductQueryKey = (id: Uuid,) => {
    return [
    `/api/v1/products/${id}`
    ] as const;
    }


export const getGetProductQueryOptions = <TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<Problem>>(id: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProduct>>> = ({ signal }) => getProduct(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductQueryResult = NonNullable<Awaited<ReturnType<typeof getProduct>>>
export type GetProductQueryError = ErrorType<Problem>


export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<Problem>>(
 id: Uuid, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProduct>>,
          TError,
          Awaited<ReturnType<typeof getProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<Problem>>(
 id: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProduct>>,
          TError,
          Awaited<ReturnType<typeof getProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<Problem>>(
 id: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary A product with its classification and warnings
 */

export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<Problem>>(
 id: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getArchiveProductUrl = (id: Uuid,) => {




  return `/api/v1/products/${encodeURIComponent(String(id))}`
}

/**
 * The product leaves the plan count and becomes read-only; its data is kept for the retention periods. Archiving again changes nothing.
 * @summary Archive a product
 */
export const archiveProduct = async (id: Uuid, options?: Parameters<typeof customerFetch>[1]): Promise<void> => {

  return customerFetch<void>(getArchiveProductUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getArchiveProductMutationKey = () => ['archiveProduct'] as const;

export const getArchiveProductMutationOptions = <TError = ErrorType<Problem>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveProduct>>, TError,ArchiveProductMutationVariables, TContext>, request?: SecondParameter<typeof customerFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveProduct>>, TError,ArchiveProductMutationVariables, TContext> => {

const mutationKey = getArchiveProductMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveProduct>>, ArchiveProductMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  archiveProduct(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveProductMutationResult = NonNullable<Awaited<ReturnType<typeof archiveProduct>>>

    export type ArchiveProductMutationError = ErrorType<Problem>
    export type ArchiveProductMutationVariables = {id: Uuid}

    /**
 * @summary Archive a product
 */
export const useArchiveProduct = <TError = ErrorType<Problem>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveProduct>>, TError,ArchiveProductMutationVariables, TContext>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveProduct>>,
        TError,
        ArchiveProductMutationVariables,
        TContext
      > => {
      return useMutation(getArchiveProductMutationOptions(options), queryClient);
    }
    export const getClassifyProductUrl = (id: Uuid,) => {




  return `/api/v1/products/${encodeURIComponent(String(id))}/classify`
}

/**
 * 400 classifier-incomplete lists the missing questions in missing[].
 * @summary Run the CRA classifier and store the result on the product
 */
export const classifyProduct = async (id: Uuid,
    classifierAnswers: ClassifierAnswers, options?: Parameters<typeof customerFetch>[1]): Promise<Product> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customerFetch<Product>(getClassifyProductUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(classifierAnswers)
  }
);}





export const getClassifyProductMutationKey = () => ['classifyProduct'] as const;

export const getClassifyProductMutationOptions = <TError = ErrorType<void | Problem>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classifyProduct>>, TError,ClassifyProductMutationVariables, TContext>, request?: SecondParameter<typeof customerFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof classifyProduct>>, TError,ClassifyProductMutationVariables, TContext> => {

const mutationKey = getClassifyProductMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof classifyProduct>>, ClassifyProductMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  classifyProduct(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClassifyProductMutationResult = NonNullable<Awaited<ReturnType<typeof classifyProduct>>>
    export type ClassifyProductMutationBody = ClassifierAnswers
    export type ClassifyProductMutationError = ErrorType<void | Problem>
    export type ClassifyProductMutationVariables = {id: Uuid;data: ClassifierAnswers}

    /**
 * @summary Run the CRA classifier and store the result on the product
 */
export const useClassifyProduct = <TError = ErrorType<void | Problem>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof classifyProduct>>, TError,ClassifyProductMutationVariables, TContext>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof classifyProduct>>,
        TError,
        ClassifyProductMutationVariables,
        TContext
      > => {
      return useMutation(getClassifyProductMutationOptions(options), queryClient);
    }
    export const getRestoreProductUrl = (id: Uuid,) => {




  return `/api/v1/products/${encodeURIComponent(String(id))}/restore`
}

/**
 * Beyond the plan the answer is 402 extra-product-required, as for creation; repeat with acceptExtraProductCharge=true (billing.manage + step-up). 409 product-not-archived, product-name-taken.
 * @summary Restore an archived product (it counts against the plan again)
 */
export const restoreProduct = async (id: Uuid,
    productRestore: ProductRestore, options?: Parameters<typeof customerFetch>[1]): Promise<Product> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customerFetch<Product>(getRestoreProductUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(productRestore)
  }
);}





export const getRestoreProductMutationKey = () => ['restoreProduct'] as const;

export const getRestoreProductMutationOptions = <TError = ErrorType<void | Problem | ExtraProductRequired>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreProduct>>, TError,RestoreProductMutationVariables, TContext>, request?: SecondParameter<typeof customerFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof restoreProduct>>, TError,RestoreProductMutationVariables, TContext> => {

const mutationKey = getRestoreProductMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restoreProduct>>, RestoreProductMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  restoreProduct(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RestoreProductMutationResult = NonNullable<Awaited<ReturnType<typeof restoreProduct>>>
    export type RestoreProductMutationBody = ProductRestore
    export type RestoreProductMutationError = ErrorType<void | Problem | ExtraProductRequired>
    export type RestoreProductMutationVariables = {id: Uuid;data: ProductRestore}

    /**
 * @summary Restore an archived product (it counts against the plan again)
 */
export const useRestoreProduct = <TError = ErrorType<void | Problem | ExtraProductRequired>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreProduct>>, TError,RestoreProductMutationVariables, TContext>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof restoreProduct>>,
        TError,
        RestoreProductMutationVariables,
        TContext
      > => {
      return useMutation(getRestoreProductMutationOptions(options), queryClient);
    }
    export const getListProductVersionsUrl = (id: Uuid,) => {




  return `/api/v1/products/${encodeURIComponent(String(id))}/versions`
}

/**
 * @summary Versions of a product, newest first
 */
export const listProductVersions = async (id: Uuid, options?: Parameters<typeof customerFetch>[1]): Promise<ProductVersion[]> => {

  return customerFetch<ProductVersion[]>(getListProductVersionsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProductVersionsQueryKey = (id: Uuid,) => {
    return [
    `/api/v1/products/${id}/versions`
    ] as const;
    }


export const getListProductVersionsQueryOptions = <TData = Awaited<ReturnType<typeof listProductVersions>>, TError = ErrorType<Problem>>(id: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductVersions>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProductVersionsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProductVersions>>> = ({ signal }) => listProductVersions(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProductVersions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProductVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof listProductVersions>>>
export type ListProductVersionsQueryError = ErrorType<Problem>


export function useListProductVersions<TData = Awaited<ReturnType<typeof listProductVersions>>, TError = ErrorType<Problem>>(
 id: Uuid, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductVersions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProductVersions>>,
          TError,
          Awaited<ReturnType<typeof listProductVersions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProductVersions<TData = Awaited<ReturnType<typeof listProductVersions>>, TError = ErrorType<Problem>>(
 id: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductVersions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProductVersions>>,
          TError,
          Awaited<ReturnType<typeof listProductVersions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProductVersions<TData = Awaited<ReturnType<typeof listProductVersions>>, TError = ErrorType<Problem>>(
 id: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductVersions>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Versions of a product, newest first
 */

export function useListProductVersions<TData = Awaited<ReturnType<typeof listProductVersions>>, TError = ErrorType<Problem>>(
 id: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductVersions>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProductVersionsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateProductVersionUrl = (id: Uuid,) => {




  return `/api/v1/products/${encodeURIComponent(String(id))}/versions`
}

/**
 * Trial workspaces have at most 2 versions per product (403 plan-limit-reached).
 * @summary Add a version
 */
export const createProductVersion = async (id: Uuid,
    versionCreate: VersionCreate, options?: Parameters<typeof customerFetch>[1]): Promise<ProductVersion> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customerFetch<ProductVersion>(getCreateProductVersionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(versionCreate)
  }
);}





export const getCreateProductVersionMutationKey = () => ['createProductVersion'] as const;

export const getCreateProductVersionMutationOptions = <TError = ErrorType<void | Problem>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductVersion>>, TError,CreateProductVersionMutationVariables, TContext>, request?: SecondParameter<typeof customerFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProductVersion>>, TError,CreateProductVersionMutationVariables, TContext> => {

const mutationKey = getCreateProductVersionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProductVersion>>, CreateProductVersionMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  createProductVersion(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProductVersionMutationResult = NonNullable<Awaited<ReturnType<typeof createProductVersion>>>
    export type CreateProductVersionMutationBody = VersionCreate
    export type CreateProductVersionMutationError = ErrorType<void | Problem>
    export type CreateProductVersionMutationVariables = {id: Uuid;data: VersionCreate}

    /**
 * @summary Add a version
 */
export const useCreateProductVersion = <TError = ErrorType<void | Problem>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductVersion>>, TError,CreateProductVersionMutationVariables, TContext>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProductVersion>>,
        TError,
        CreateProductVersionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateProductVersionMutationOptions(options), queryClient);
    }
    export const getUpdateVersionUrl = (id: Uuid,) => {




  return `/api/v1/versions/${encodeURIComponent(String(id))}`
}

/**
 * in_development → on_market → end_of_support → withdrawn; placedOnMarketAt defaults to now when a version goes on the market.
 * @summary Rename a version or move its lifecycle forward
 */
export const updateVersion = async (id: Uuid,
    versionUpdate: VersionUpdate, options?: Parameters<typeof customerFetch>[1]): Promise<ProductVersion> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customerFetch<ProductVersion>(getUpdateVersionUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(versionUpdate)
  }
);}





export const getUpdateVersionMutationKey = () => ['updateVersion'] as const;

export const getUpdateVersionMutationOptions = <TError = ErrorType<Problem>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVersion>>, TError,UpdateVersionMutationVariables, TContext>, request?: SecondParameter<typeof customerFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateVersion>>, TError,UpdateVersionMutationVariables, TContext> => {

const mutationKey = getUpdateVersionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVersion>>, UpdateVersionMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateVersion(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateVersionMutationResult = NonNullable<Awaited<ReturnType<typeof updateVersion>>>
    export type UpdateVersionMutationBody = VersionUpdate
    export type UpdateVersionMutationError = ErrorType<Problem>
    export type UpdateVersionMutationVariables = {id: Uuid;data: VersionUpdate}

    /**
 * @summary Rename a version or move its lifecycle forward
 */
export const useUpdateVersion = <TError = ErrorType<Problem>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVersion>>, TError,UpdateVersionMutationVariables, TContext>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateVersion>>,
        TError,
        UpdateVersionMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateVersionMutationOptions(options), queryClient);
    }
    export const getGetVersionUrl = (id: Uuid,) => {




  return `/api/v1/versions/${encodeURIComponent(String(id))}`
}

/**
 * @summary One version (REQUESTS #54e: deep links without the product id)
 */
export const getVersion = async (id: Uuid, options?: Parameters<typeof customerFetch>[1]): Promise<ProductVersion> => {

  return customerFetch<ProductVersion>(getGetVersionUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetVersionQueryKey = (id: Uuid,) => {
    return [
    `/api/v1/versions/${id}`
    ] as const;
    }


export const getGetVersionQueryOptions = <TData = Awaited<ReturnType<typeof getVersion>>, TError = ErrorType<Problem>>(id: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVersionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVersion>>> = ({ signal }) => getVersion(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getVersion>>>
export type GetVersionQueryError = ErrorType<Problem>


export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = ErrorType<Problem>>(
 id: Uuid, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersion>>,
          TError,
          Awaited<ReturnType<typeof getVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = ErrorType<Problem>>(
 id: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersion>>,
          TError,
          Awaited<ReturnType<typeof getVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = ErrorType<Problem>>(
 id: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One version (REQUESTS #54e: deep links without the product id)
 */

export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = ErrorType<Problem>>(
 id: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVersionQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDiffVersionsUrl = (id: Uuid,
    params: DiffVersionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/versions/${encodeURIComponent(String(id))}/diff?${stringifiedParams}` : `/api/v1/versions/${encodeURIComponent(String(id))}/diff`
}

/**
 * @summary Components added, removed and changed compared with another version of the same product
 */
export const diffVersions = async (id: Uuid,
    params: DiffVersionsParams, options?: Parameters<typeof customerFetch>[1]): Promise<VersionDiff> => {

  return customerFetch<VersionDiff>(getDiffVersionsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDiffVersionsQueryKey = (id: Uuid,
    params?: DiffVersionsParams,) => {
    return [
    `/api/v1/versions/${id}/diff`, ...(params ? [params] : [])
    ] as const;
    }


export const getDiffVersionsQueryOptions = <TData = Awaited<ReturnType<typeof diffVersions>>, TError = ErrorType<Problem>>(id: Uuid,
    params: DiffVersionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof diffVersions>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDiffVersionsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof diffVersions>>> = ({ signal }) => diffVersions(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof diffVersions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DiffVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof diffVersions>>>
export type DiffVersionsQueryError = ErrorType<Problem>


export function useDiffVersions<TData = Awaited<ReturnType<typeof diffVersions>>, TError = ErrorType<Problem>>(
 id: Uuid,
    params: DiffVersionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof diffVersions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof diffVersions>>,
          TError,
          Awaited<ReturnType<typeof diffVersions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiffVersions<TData = Awaited<ReturnType<typeof diffVersions>>, TError = ErrorType<Problem>>(
 id: Uuid,
    params: DiffVersionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof diffVersions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof diffVersions>>,
          TError,
          Awaited<ReturnType<typeof diffVersions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDiffVersions<TData = Awaited<ReturnType<typeof diffVersions>>, TError = ErrorType<Problem>>(
 id: Uuid,
    params: DiffVersionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof diffVersions>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Components added, removed and changed compared with another version of the same product
 */

export function useDiffVersions<TData = Awaited<ReturnType<typeof diffVersions>>, TError = ErrorType<Problem>>(
 id: Uuid,
    params: DiffVersionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof diffVersions>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDiffVersionsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetVersionHistoryUrl = (id: Uuid,
    params?: GetVersionHistoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/versions/${encodeURIComponent(String(id))}/history?${stringifiedParams}` : `/api/v1/versions/${encodeURIComponent(String(id))}/history`
}

/**
 * @summary What happened to a version, newest first: created, SBOM revisions, scans, findings found, triaged and resolved
 */
export const getVersionHistory = async (id: Uuid,
    params?: GetVersionHistoryParams, options?: Parameters<typeof customerFetch>[1]): Promise<VersionHistoryEntry[]> => {

  return customerFetch<VersionHistoryEntry[]>(getGetVersionHistoryUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetVersionHistoryQueryKey = (id: Uuid,
    params?: GetVersionHistoryParams,) => {
    return [
    `/api/v1/versions/${id}/history`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetVersionHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getVersionHistory>>, TError = ErrorType<Problem>>(id: Uuid,
    params?: GetVersionHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersionHistory>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVersionHistoryQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVersionHistory>>> = ({ signal }) => getVersionHistory(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVersionHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVersionHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getVersionHistory>>>
export type GetVersionHistoryQueryError = ErrorType<Problem>


export function useGetVersionHistory<TData = Awaited<ReturnType<typeof getVersionHistory>>, TError = ErrorType<Problem>>(
 id: Uuid,
    params: undefined |  GetVersionHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersionHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersionHistory>>,
          TError,
          Awaited<ReturnType<typeof getVersionHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVersionHistory<TData = Awaited<ReturnType<typeof getVersionHistory>>, TError = ErrorType<Problem>>(
 id: Uuid,
    params?: GetVersionHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersionHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersionHistory>>,
          TError,
          Awaited<ReturnType<typeof getVersionHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVersionHistory<TData = Awaited<ReturnType<typeof getVersionHistory>>, TError = ErrorType<Problem>>(
 id: Uuid,
    params?: GetVersionHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersionHistory>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What happened to a version, newest first: created, SBOM revisions, scans, findings found, triaged and resolved
 */

export function useGetVersionHistory<TData = Awaited<ReturnType<typeof getVersionHistory>>, TError = ErrorType<Problem>>(
 id: Uuid,
    params?: GetVersionHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersionHistory>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVersionHistoryQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






